<template>
    <path d="M18.033 0v2.393h7.881L10.91 17.408l1.683 1.683L27.607 4.086v7.88H30V0H18.033zM4.91 5.455C2.196 5.455 0 7.65 0 10.364V25.09C0 27.804 2.196 30 4.91 30h14.726c2.714 0 4.91-2.196 4.91-4.91V12.819l-2.455 2.455v9.818c0 1.352-1.103 2.454-2.455 2.454H4.91c-1.352 0-2.454-1.102-2.454-2.454V10.364c0-1.352 1.102-2.455 2.454-2.455h9.818l2.455-2.454H4.909z"/>
</template>

<script>
export default {
    name: 'externalLinkIcon',
    beforeMount() {
        this.$parent.$emit('size', '0 0 30 30');
    }
}
</script>
